import { useSiteConfig } from '@/feature/config/hooks/useSiteConfig.client'
import { useIsAuthenticated } from '@/lib/auth/client/AuthProvider.client'
import { ProductType } from '@gql-generated/graphql'
import { useMemo } from 'react'
import type { MergedProduct } from '../types/mergedProduct'
import { getAvailabilityIssue, hasDisplayablePrice } from '../utils/productBuyBox'

type UseProductBuyBoxProps = {
  product: MergedProduct
}

export const useProductBuyBox = ({ product }: UseProductBuyBoxProps) => {
  const { config } = useSiteConfig()

  const isAuthenticated = useIsAuthenticated()
  const isPublicPriceEnabled = config?.catalog?.isPublicPricesEnabled ?? false

  const isProduct = product.type === ProductType.Product
  const isArticle = product.type === ProductType.Article
  const isMonoDiscriminant = isProduct && (product.filters?.length || 0) === 1

  const availabilityIssue = useMemo(
    () =>
      getAvailabilityIssue({
        product,
        isPublicPriceEnabled,
        isProduct,
        isAuthenticated,
      }),
    [product, isPublicPriceEnabled, isProduct, isAuthenticated],
  )

  const hasPrice = hasDisplayablePrice({ product, isProduct, availabilityIssue })
  const showPricesAndEcoPart = isPublicPriceEnabled || isAuthenticated

  return {
    isPublicPriceEnabled,
    isProduct,
    isArticle,
    availabilityIssue,
    hasPrice,
    showPricesAndEcoPart,
    isMonoDiscriminant,
  }
}
